// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".v-data-footer{justify-content:center}.data-table__pre-header{border-bottom:1px solid var(--pale-sky-blue)}.v-expansion-panel-content__wrap{padding:12px!important}.v-expansion-panel.v-expansion-panel--active #divider{top:64px}.v-expansion-panel #divider{transition:all .25s ease-in-out;position:absolute;background:var(--pale-sky-blue);top:51px;left:0;right:0}", ""]);
// Exports
module.exports = exports;
